import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ParticipantRelationship } from '@app/modules/service-data/types/paternity.types';
import { Gender } from '@app/modules/service-data/types/service-data.types';

const NAME_PATTERN = /^(?!.*[\\/:*?"<>|]).*$/;

// Additional Paternity participant (the patient is participant 1).
// Validators live here, because a ValidationPair can't address array items.
export function createPaternityParticipantGroup(): FormGroup {
  return new FormGroup({
    // Generated on save, kept afterwards so samples can reference it
    id: new FormControl<string>(null),
    firstName: new FormControl('', [
      Validators.required,
      Validators.pattern(NAME_PATTERN),
    ]),
    lastName: new FormControl('', [
      Validators.required,
      Validators.pattern(NAME_PATTERN),
    ]),
    dateOfBirth: new FormControl(null, Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
    gender: new FormControl<Gender>(null, Validators.required),
    relationship: new FormControl<ParticipantRelationship>(
      null,
      Validators.required
    ),
  });
}
